class Share {
    constructor() {
        this.platform = this.getPlatform();
    }

    getUrl() {
        return window.location.href;
    }

    getPlatform() {
        let userAgent = window.navigator.userAgent;
        let platform = window.navigator.platform;
        let macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
        let windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
        let iosPlatforms = ["iPhone", "iPad", "iPod"];

        if (
            iosPlatforms.indexOf(platform) !== -1 ||
            /Android/.test(userAgent)
        ) {
            return "mobile";
        }

        if (
            macosPlatforms.indexOf(platform) !== -1 ||
            windowsPlatforms.indexOf(platform) !== -1 ||
            /Linux/.test(platform)
        ) {
            return "desktop";
        }

        return null;
    }

    facebook() {
        var url = `https://www.facebook.com/sharer/sharer.php?u=${this.getUrl()}&t=${encodeURI(
            document.title
        )}`;
        window.open(
            url,
            "",
            "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
        );
        return false;
    }

    twitter() {
        var url = `https://x.com/intent/post?url=${this.getUrl()}&via=AssetplanChile&text=${encodeURI(
            document.title
        )}`;
        window.open(url, "", 600, 300);
    }

    linkedin() {
        let url = `https://www.linkedin.com/sharing/share-offsite/?url=${this.getUrl()}&title=${encodeURI(
            document.title
        )}`;
        window.open(url, "", 600, 300);
    }

    copyLink() {
        let base_url = this.getUrl();
        this.copyToClipboard(base_url).then(
            function () {
                let event = new CustomEvent("share-done");
                window.dispatchEvent(event);
                console.log(
                    "Async: Copying to clipboard was successful!" + base_url
                );
            },
            function (err) {
                console.error("Async: Could not copy text: ", err);
            }
        );
    }

    copyToClipboard(textToCopy) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(textToCopy);
        } else {
            let textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((res, rej) => {
                document.execCommand("copy") ? res() : rej();
                textArea.remove();
            });
        }
    }

    self() {
        if (this.platform == "desktop") {
            let event = new CustomEvent("modal-share");
            window.dispatchEvent(event);
        } else {
            if (navigator.share) {
                navigator
                    .share({
                        title: document.title,
                        url: this.getUrl(),
                    })
                    .then(() => {
                        console.log("Thanks for sharing!");
                    })
                    .catch(console.error);
            } else {
                console.log("Dont support Web Share API");
            }
        }
    }
}

export default Share;
